@if (!isCompoundFieldMember && showLabel) {
<label
  soho-label
    [required]="required$ | async"
    [attr.for]="id"
    [layoutInfo]="layoutInfo"
  lm-label
    [layoutField] = "field"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize && !field?.label?.textStyle?.color"
  lm-text-style
    [textStyle]="field?.label?.textStyle"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>
}

@switch (formType) {
  @case (formDisplayType.SEARCH_FORM) {
    @if (isCompoundFieldMember) {
      <!-- On a search form and in the preview mode (occurs in the lm-compact-dialog modal) -->
      @if (lmParagraphLayoutInfo.previewMode) {
        <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayPreviewMode"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="NormalMode"></ng-container>
      }
      <!-- On a search form, just a compound field member NOT in the preview -->
      <ng-template #NormalMode>
        <div>
          <input
            #Input
            [ngClass]="fieldClassesString"
            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            soho-alert
            soho-datepicker
              [options]="pickerOptions"
              [mode]="mode"
              [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
              (focus)="onFocus($event)"
              (blur)="onBlur($event)"
              (change)="onDateChange()"
          />
          <!-- Handle displaying the label or value as text when not showField (the field isn't focused)-->
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayNormalMode"></ng-container>
        </div>
      </ng-template>
    } @else {
      <!-- On a search form, NOT a compound member field-->
      <input
        #Input
        [ngClass]="fieldClassesString"
        [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
        [attr.id]="id"
        [attr.bindId]="bindId"
        [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
        (ngModelChange)="onNgModelChange($event)"
        soho-alert
        soho-datepicker
          [options]="pickerOptions"
          [mode]="mode"
          [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
          [attr.aria-describedby]="fieldDescriptionId"
        soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
        soho-field-filter
          [fieldDropdownDataSet]="filterSettings"
          [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
          (filtered)="onFiltered($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        (change)="onDateChange()"
        (keyup.enter)="onEnterUp()"
      />
        @if (layoutInfo.isAdHoc) {
          <button
            id="AdHocRemove"
            class="lm-compound-field-dialog-button lm-adhoc-remove"
            soho-button="icon"
            [icon]="'close-small'"
            soho-tooltip
            [content]="'Remove Field'"
            (click)="removeAdHocField($event)"
          ></button>
        }
    }
  }
  @default {
    <!-- Not on a search form -->
    <div
      [ngClass]="{'disabled-member-field': disabledMemberField, 'lm-is-display-as-tag': layoutDisplayType.DISPLAY_AS_TAG}"
      lm-field-options
        [isMemberField]="isCompoundFieldMember"
        [dataEntryMode]="dataEntryMode"
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [disableFieldOptions]="disableFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      lm-layout-util
        [hideWhiteSpace]="shouldHideWhiteSpace"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
      (focus)="onFocus($event)"
      (contextmenu)="onContextMenu($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)">
      @switch (displayType) {
        @case (layoutDisplayType.DATE) {
          <!-- wrapper div so icon doesn't float outside of container -->
          <div [ngStyle]="{'display': showField ? 'inline-block' : 'none'}">
            <input
              #Input
              [ngClass]="fieldClassesString"
              [attr.id]="id"
              [attr.bindId]="bindId"
              [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
              [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : null"
              [attr.aria-describedby]="fieldDescriptionId"
              [ngModel]="updateDisplay$ | async | toDisplayValue:specField:transformOptions"
              (ngModelChange)="onNgModelChange($event)"
              soho-datepicker
                [options]="pickerOptions"
                [mode]="mode"
                [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
              soho-alert
              soho-trackdirty
                [searchForm]="onSearchForm"
                (dirty)="onDirty($event)"
                (pristine)="onPristine($event)"
                (afterResetDirty)="onAfterResetDirty($event)"
              soho-input-validate
                (error)="onError($event)"
                (valid)="onValid($event)"
              (blur)="onBlur($event)"
              (input)="onInput($event)"
              (change)="onDateChange()"
            />
          </div>
        }

        <!-- display as tag -->
        @case (layoutDisplayType.TAG) {
          <span
              attr.id="{{id}}"
              class="tag is-dismissible"
              [ngClass]="{
                'lm-compound-text': isCompoundFieldMember,
                'lm-text-data ': !isCompoundFieldMember,
                'is-active': isFieldTagFocused,
                'is-focused': isFieldTagFocused,
                'hide-focus': !isFieldTagFocused
                }"
              [ngStyle]="{'display': showField ? 'inline-block' : 'none', 'color': '#FFFFFF', 'outline': 'none'}"
              soho-alert
              lm-field-style
                [fieldStyle]="tagStyle?.style"
                [specField]="specField"
                [isTag]="true"
                [recalculateStyles]="triggerValueChange | async"
              [attr.tabindex]="isInAccessibilityMode ? 0 : null"
              (focus)="onTagFocus()"
              (blur)="onTagBlur()"
          >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</span>
        }

        <!-- display as text -->
        @case (layoutDisplayType.TEXT) {
          <p
              attr.id="{{id}}"
              class="hide-white-space"
              [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
              [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
              [class.lm-compound-text]="isCompoundFieldMember"
              [class.lm-text-data]="!isCompoundFieldMember"
              soho-alert
              lm-field-style
                [fieldStyle]="layoutObject.fieldStyle"
                [specField]="specField"
                [recalculateStyles]="triggerValueChange | async"
          >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:layoutObject.title:model:specFields}}</p>
        }
      }

      <!-- Handle the compound field member display label/value not focused in compact format on a form -->
      @if (isCompoundFieldMember) {
        @if (lmParagraphLayoutInfo?.previewMode) {
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayPreviewMode"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayNormalMode"></ng-container>
        }
      }
    </div>
  }
}

<ng-template #CompoundPlaceHolderDisplayNormalMode>
  @if (dirtyCompoundField) {
    <span class="icon-dirty lm-compound-member-field-dirty"></span>
  }
  @if (!(modelField.valueChanged | async | isBlankValue:specField)) {
    <p
        attr.id="{{id}}-text"
        class="lm-compound-text hide-white-space"
        [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
        [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
        (focus)="onFocus($event)"
    >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
  } @else {
    <p
        attr.id="{{id}}-text"
        [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
        [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
        [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !(readOnly$ | async)}"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="showLabel ? '' : triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
        (focus)="onFocus($event)"
    >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  }
</ng-template>

<ng-template #CompoundPlaceHolderDisplayPreviewMode>
  @if (!(modelField.valueChanged | async | isBlankValue:specField)) {
    <p
        attr.id="{{id}}-text"
        class="lm-compound-text hide-white-space"
        [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
        [ngStyle]="{'display': 'inline-block', 'vertical-align': 'unset'}"
        soho-alert
    >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
  } @else {
    <p
        attr.id="{{id}}-text"
        class="lm-compound-text input-style is-placeholder preview-placeholder"
        [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="showLabel ? '' : triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
    >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  }
</ng-template>

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}